<template>
  <div class="mb-3">
    <custom-callout
      border-color="#B5C3BC"
      :controlled="true"
      :has-toggle="false"
    >
      <div class="row mt-2">
        <div
          class="col-sm-12 col-md-2 col-lg-2 py-3 border-right-2 d-flex flex-column align-items-start justify-content-start"
        >
          <custom-balloon
            :background-color="getPeiStatusClass()"
            class="w-100 p-2 mt-2"
            :text="value.peiStatusDescription"
          />
        </div>
        <div class="col-12 col-lg-8 pt-3 grey-divider">
          <div :class="['row', { 'pt-2': isMobile }]">
            <div class="col-lg-2 col-12">
              <div class="info-text-title">Año</div>
              <p>
                {{ value.academicYear }}
              </p>
            </div>
            <div class="col-lg-1 col-12">
              <div class="info-text-title">Tipo</div>
              <p>
                {{ getPeiTypeDesc }}
              </p>
            </div>
            <div class="col-lg-2 col-12">
              <div class="info-text-title">Número</div>
              <p>
                {{ parsePeiId }}
              </p>
            </div>
            <div class="col-lg-2 col-12">
              <div class="info-text-title">Enmienda</div>
              <p>
                {{ parseGeneralRevisionNo }}
              </p>
            </div>
            <div class="col-lg-2 col-12">
              <div class="info-text-title">Fecha Discusión COMPU</div>
              <p>
                {{ value.generalClosedDate | date('DD/MMM/YYYY') }}
              </p>
            </div>
            <div class="col-lg-3 col-12">
              <div class="info-text-title">Fecha Inicio de Servicio</div>
              <p>
                {{ value.projectedDate.projectedDate | date('DD/MMM/YYYY') }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-2 pt-3">
          <div class="row w-100 custom-button d-flex justify-content-end">
            <DropDown
              id="dd-actions"
              :key="value.peiIdFormatted"
              :items="getMenuItems"
            />
          </div>
        </div>
      </div>
    </custom-callout>
    <Error
      v-if="value.atServiceAmmendment || value.signedWithoutChecklist"
      :can-close="false"
      class="px-3"
      is-alert-mode
      is-borderless
      message="Esta Enmienda de PEI fue generada por proceso de Asistencia Tecnológica"
      @close="closeErrorPanel()"
    />
    <Error
      v-if="value.hasCommentFromParentPortal && showError"
      can-close
      is-alert-mode
      is-borderless
      message="El PEI cuenta con un comentario realizado por el padre, madre y/o encargado(o). Favor dirigirse a los comentarios."
      @close="closeErrorPanel()"
    />
  </div>
</template>

<script>
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import CustomCallout from 'custom-callout';
import Error from '@/components/common/Error.vue';
import PeiStatus from '@/utils/constants/peiStatus';
import userRoles from '@/utils/constants/userRoles';
import mixAlert from '@/mixins/alert.mixin';

export default {
  name: 'PeiHistoryRow',
  components: {
    CustomBalloon,
    CustomCallout,
    DropDown,
    Error,
  },
  mixins: [mixAlert],
  props: {
    value: {
      type: Object,
      required: true,
    },
    hasSaee10Report: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showError: true,
      reportUpdateRoles: [
        userRoles.admin,
        userRoles.adminIl,
        userRoles.adminSaee,
        userRoles.tecnico,
      ],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    isPS() {
      return this.value.unilateralFlag !== '0';
    },
    getPeiTypeDesc() {
      return this.isPS ? 'PS' : 'PEI';
    },
    parseGeneralRevisionNo() {
      return this.value.generalRevisionNo.toString().padStart(2, '0');
    },
    parsePeiId() {
      return (
        this.value.peiIdFormatted.slice(0, 4) +
        '-' +
        this.value.peiIdFormatted.slice(4, 10)
      );
    },
    getMenuItems() {
      const validStatus = ![PeiStatus.Cancelado, PeiStatus.Incompleto].includes(
        this.value.peiStatusId
      );

      return [
        { visible: false },
        {
          label: 'Descargar',
          icon: 'fa fa-file-download text-green',
          click: () => this.$emit('getReportsPEIPS'),
          visible: validStatus && !this.value.canDownloadFromStorage,
        },
        {
          label: 'Imprimir PEI o PS Firmado',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getReportsPEIPSFromStorage'),
          visible: this.value.canDownloadFromStorage,
        },
      ];
    },
  },
  methods: {
    getPeiStatusColor() {
      let statusClass = 'brown';

      switch (this.value.peiStatusId.toString()) {
        case PeiStatus.Borrador:
          statusClass = 'pink';
          break;
        case PeiStatus.Cancelado:
          statusClass = 'brown';
          break;
        case PeiStatus.Completado:
          statusClass = 'yellow';
          break;
        case PeiStatus.Firmado:
          statusClass = 'green-light';
          break;
        case PeiStatus.Incompleto:
          statusClass = 'brown';
          break;
        case PeiStatus.CompletedWithPendingFunds:
          statusClass = 'yellow';
          break;
        case PeiStatus.PartialSignedPendingFunds:
          statusClass = 'green-light';
          break;
        case PeiStatus.SignedWithControversy:
          statusClass = 'green-light';
          break;
        case PeiStatus.ProposalRejected:
          statusClass = 'violet';
          break;
      }

      return statusClass;
    },
    getPeiStatusClass() {
      let statusClass = '';
      switch (this.value.peiStatusId.toString()) {
        case PeiStatus.Borrador:
          statusClass = 'pink';
          break;
        case PeiStatus.Cancelado:
          statusClass = 'brown';
          break;
        case PeiStatus.Completado:
          statusClass = 'yellow';
          break;
        case PeiStatus.Firmado:
          statusClass = 'green-light';
          break;
        case PeiStatus.Incompleto:
          statusClass = 'brown';
          break;
        case PeiStatus.CompletedWithPendingFunds:
          statusClass = 'violet';
          break;
        case PeiStatus.PartialSignedPendingFunds:
          statusClass = 'green-light';
          break;
        case PeiStatus.SignedWithControversy:
          statusClass = 'green-light';
          break;
        case PeiStatus.ProposalRejected:
          statusClass = 'violet';
          break;
      }

      return statusClass;
    },
    closeErrorPanel() {
      this.showError = false;
      this.$emit('closeShowErrorPanel');
    },
  },
};
</script>

<style scoped>
.student-search-alert-error {
  margin: 0 !important;
}

/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  width: 100%;
  height: 42px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}
.badge-erase {
  background: #fcc9c8;
}
.badge-cancel {
  background: #d5b89a;
}
.badge-complete {
  background: #f8ea80;
}
.badge-signed {
  background: #a3e5b3;
}
.badge-incomplete {
  background: #d5b89a;
}
.badge-waiting {
  background: #a7e6dc;
}
.badge-partial {
  background: #a3e5b3;
}
.badge-pending-funds {
  background: #ddb3d7;
}
.badge-pending {
  background: #f8ea80;
}
</style>
